<template>
    <main-content>
        <div v-if="status !== 'loading'">
            <notification-form
                    :form_data="form_data"
                    :submit="submit"
            >
            </notification-form>
            <sms-wallet
                    :form_data="form_data"
                    :set_sms_wallet="set_sms_wallet"
            >
            </sms-wallet>
            <set-sms-price
                    v-if="$can('read', 'ipg-gateway')"
                    :form_data="form_data"
                    :submit_sms_price="submit_sms_price"
            >
            </set-sms-price>
         </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {mapGetters,mapActions} from "vuex"
    import $ from "jquery"
    import { KTApp } from '@/plugins/core/app'
    import { notificationSmsService } from '@/common/api.service'
    import notificationForm from './components/form'
    import smsWallet from './components/sms-wallet'
    import setSmsPrice from './components/sms-price'
    import { i18n } from '@/plugins/i18n'
    import { BASE_PATH } from "../../common/config";

    export default {
        name: "NotificationSmsGet",

        components: {
            'main-content': mainContent,
            'notification-form': notificationForm,
            'sms-wallet':smsWallet,
            'set-sms-price':setSmsPrice
        },
        computed: {
            ...mapGetters('notificationSms', [
                'form_data', 'status',
            ]),
            ...mapActions('notificationSms',['increment'])
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('notificationSms/fetch')
            })
        },
        methods: {
            set_sms_wallet(e){

                let form=$('#settings_sms_wallet_form')
                let btn = $('#submit_btn_sms_wallet')

                if($('#recharge_price').val() < 10000) {
                    return
                }

                KTApp.progress(btn)

                let params = {
                    recharge_price: $('#recharge_price').val(),
                }
                notificationSmsService.updateSmsWallet(params).then(response=> {
                    let tracking_code = response.data.data.tracking_code
                    window.location = BASE_PATH + '/notification-sms/pay-recharge-wallet/' + tracking_code;
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
                }).finally(() => {
                        KTApp.unprogress(btn)
                    }
                );
           },
            submit_sms_price(e){

                let form=$('#settings_sms_price_form')
                let btn = $('#submit_btn_sms_price')
                KTApp.progress(btn)

                let params = this.$store.getters['notificationSms/form_data']
                notificationSmsService.updatsetSmsPrice(params).then(response=> {
                    this.showMsg(form, 'success', response.data.message)
                }).catch(({response}) => {
                     this.showMsg(form, 'danger', response.data.message)
                 }).finally(() => {
                     KTApp.unprogress(btn)
                            }
                 );

            },
            submit(e) {
                let form = $('#settings_form')
                let btn = $('#submit_btn')

                KTApp.progress(btn)

                let params = this.$store.getters['notificationSms/form_data']

                notificationSmsService.update(params).then(response => {
                    this.showMsg(form, 'success', response.data.message)
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                })
                    .finally(() => {
                            KTApp.unprogress(btn)
                        }
                    )
            },
        },
    }
</script>

<style scoped>

</style>
